module.exports = __webpack_public_path__ + "img/profile.b347f0d4.webp";